import { ContractItem } from '~/data/contract';

import { parseFromInput } from '@vestigas/utils';

/*
  Calculates the total price of a contract item based on the quantity ordered, the gross price per quantity, and the gross price.
  @param item - The contract item.
  @param locale - The locale to use for parsing the numbers.
  @returns The total price, or `undefined` when the item has no ordered quantity (an explicit 0 is a defined quantity).
*/
export function calculateContractItemTotalPrice(
  item: ContractItem,
  locale: string = 'de',
): number | undefined {
  const q = parseFromInput(item.quantityOrdered, { locale });

  if (q === null) {
    return undefined;
  }

  const ppq = parseFromInput(item.grossPricePerQuantity, { locale }) || 1;
  const gp = parseFromInput(item.grossPrice, { locale }) || 0;

  return (q / ppq) * gp;
}
